import { DuplexerEvent } from '@wix/a11y-wizard-common';
import { useMemo } from 'react';
import { SITE_LEVEL_PAGE_ID } from '../consts';
import { AnalysisState, usePanelStateAtom } from '../hooks/rules-state';
import { useScanTimeoutManager } from '../hooks/scan-timeout';
import { isStaticPage } from '../rule-mappers/shared/helpers';
export const useGetDuplexerEventHandlers = () => {
  const {
    setGroupAnalysisData,
    setGroupData,
    setGroupsAnalysisState,
    incrementFailedPagesTpa,
    getGroupData
  } = usePanelStateAtom();
  const {
    clearScanTimeoutsForItemType,
    clearPageScanTimeout
  } = useScanTimeoutManager();
  const duplexerEventHandlers = useMemo(() => ({
    [DuplexerEvent.AnalyzePageCompleted]: payload => {
      var _getGroupData;
      const {
        pageId
      } = payload;
      const pagesDataItemType = (_getGroupData = getGroupData(pageId)) == null ? void 0 : _getGroupData.itemType;
      if (!isStaticPage(pagesDataItemType)) {
        setGroupAnalysisData({
          data: payload,
          itemType: pagesDataItemType
        });
      } else {
        setGroupAnalysisData({
          data: payload,
          pageId
        });
      }
      clearPageScanTimeout(pageId);
    },
    [DuplexerEvent.AnalyzePageFailed]: payload => {
      const {
        pageId,
        itemType
      } = payload;
      setGroupData(pageId, {
        analysisState: AnalysisState.AnalyzeFailed
      });
      if (!isStaticPage(itemType)) {
        incrementFailedPagesTpa(itemType);
      }
      clearPageScanTimeout(pageId);
    },
    [DuplexerEvent.AnalyzeSiteLevelCompleted]: payload => {
      setGroupAnalysisData({
        data: payload,
        pageId: SITE_LEVEL_PAGE_ID
      });
      clearPageScanTimeout(SITE_LEVEL_PAGE_ID);
    },
    [DuplexerEvent.AnalyzeSiteLevelFailed]: _payload => {
      setGroupData(SITE_LEVEL_PAGE_ID, {
        analysisState: AnalysisState.AnalyzeFailed
      });
      clearPageScanTimeout(SITE_LEVEL_PAGE_ID);
    },
    [DuplexerEvent.AnalyzeJobCompleted]: payload => {
      const {
        type
      } = payload;
      if (!isStaticPage(type)) {
        setGroupAnalysisData({
          data: payload,
          isJobCompleted: true,
          itemType: type
        });
      }
    },
    [DuplexerEvent.AnalyzeJobFailed]: payload => {
      const {
        type: itemType
      } = payload;
      clearScanTimeoutsForItemType(itemType);
      setGroupsAnalysisState(AnalysisState.AnalyzeFailed, itemType);
    }
  }), [getGroupData, setGroupAnalysisData, clearPageScanTimeout, setGroupData, incrementFailedPagesTpa, clearScanTimeoutsForItemType, setGroupsAnalysisState]);
  return duplexerEventHandlers;
};
//# sourceMappingURL=use-get-duplexer-event-handlers.js.map